export const IconTemplate = ({ className, size = '48', color = "#F8FAFA" }) => {
  return (
    <svg data-hover="pathFill" className={className} width={size} height={size} viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
      <path d="M24 0C24.4686 13.0558 34.9442 23.5314 48 24C34.9442 24.4686 24.4686 34.9442 24 48C23.5314 34.9442 13.0558 24.4686 0 24C13.0558 23.5314 23.5314 13.0558 24 0Z" fill={color} />
    </svg>
  )
}
